/**
=========================================================

* Tazi Rides Ltd has developed this dashboard based on a further configured version of the original template.
* Website: https://www.tazirides.co.uk
* All rights reserved.

=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

* This template has been built upon, with additional code and configuration by Tazi Rides Ltd.
*/

// Material Dashboard 2 PRO React TS Base Styles
import colors from 'assets/theme-dark/base/colors'
import typography from 'assets/theme-dark/base/typography'

const { grey } = colors
const { size } = typography

// types
type Types = any

const breadcrumbs: Types = {
	styleOverrides: {
		li: {
			lineHeight: 0,
		},

		separator: {
			fontSize: size.sm,
			color: grey[600],
		},
	},
}

export default breadcrumbs
